import { uiActions, financialStatementsSelectors } from '~/store';
import { MAIN_SCREEN_MODALS } from '~/lib/constants';
// ---- internal imports ----


function displayFinancialStatementNotSubmittedPopup(state) {
	if (!shouldDisplay(state)) {
		return;
	}

	return uiActions.changeActiveModal(MAIN_SCREEN_MODALS.FINANCIAL_STATEMENTS_NOT_SUBMITTED_MODAL);
}

function shouldDisplay(state) {
	return financialStatementsSelectors
		.shouldDisplayFinancialStatementsNotSubmittedPopup(state);
}


export default displayFinancialStatementNotSubmittedPopup;
